import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule, HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { RippleModule } from 'primeng/ripple';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ButtonModule } from 'primeng/button';
import { AppLayoutModule } from './layout/app.layout.module';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { TokenInterceptor } from './custom-headers.service';
import { MsauthComponent } from './msauth/msauth/msauth.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MonitoringService } from './servies/monitoring.service';
import { GlobalErrorHandler } from './servies/GlobalErrorHandler.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
@NgModule({
    declarations: [
        AppComponent,
        MsauthComponent
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        ButtonModule,
        InputTextModule,
        CheckboxModule,
        FormsModule,
        RippleModule,
        RouterModule,
        AppLayoutModule,
        DropdownModule,
        TableModule,
        ProgressSpinnerModule ,
        PdfViewerModule
    ],
    providers: [
        provideHttpClient(),

        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        MonitoringService,
        { provide: ErrorHandler, useClass: GlobalErrorHandler }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
